<template>
  <div id="particles-js"></div>
</template>

<script>
import particlesJS from 'particles.js';

export default {
  name: 'ParticlesBackground',
  mounted() {
    // 确保使用 window.particlesJS
    if (window.particlesJS) {
      window.particlesJS.load('particles-js', '/particles.json', () => {
        console.log('Particles.js loaded successfully');
      });
    } else {
      console.error('particlesJS is not available');
    }
  },
  methods: {
    initParticles() {
      particlesJS.load('particles-js', '/particles.json', () => {
        console.log('Particles.js loaded');
      });
    }
  }
};
</script>

<style scoped>
#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1; /* 确保背景在内容下方 */
}

:deep(canvas) {
  background: transparent !important;
  filter: none !important; /* 防止颜色反转 */
  mix-blend-mode: normal !important; /* 防止混合模式异常 */
}
</style>
